// extracted by mini-css-extract-plugin
export default {"pageWrap":"_e-z"};